export default {
  Amazon: 'channels.Amazon',
  API: 'channels.API',
  BackerKit: 'channels.BackerKit',
  BigCommerce: 'channels.BigCommerce',
  CrateJoy: 'channels.CrateJoy',
  Ebay: 'channels.Ebay',
  Excel: 'channels.Excel',
  Exchange: 'channels.Exchange',
  ExternalInventoryTransfer: 'channels.ExternalInventoryTransfer',
  InternalInventoryTransfer: 'channels.InternalInventoryTransfer',
  Magento: 'channels.Magento',
  ManualOrder: 'channels.ManualOrder',
  PrepaidFreight: 'channels.PrepaidFreight',
  PrepaidStandardCarrier: 'channels.PrepaidStandardCarrier',
  Return: 'channels.Return',
  ShipStation: 'channels.ShipStation',
  Shopify: 'channels.Shopify',
  SquareSpace: 'channels.SquareSpace',
  StitchLabs: 'channels.StitchLabs',
  TicTail: 'channels.TicTail',
  Walmart: 'channels.Walmart',
  WarehouseReceiving: 'channels.WarehouseReceiving',
  WooCommerce: 'channels.WooCommerce',
  WooCommerceV2: 'channels.WooCommerceV2',
  Zapier: 'channels.Zapier',
  ManualB2B: 'channels.ManualB2B',
  ClientWarehouseOrder: 'channels.ClientWarehouseOrder',
  ExchangeOrder: 'channels.ExchangeOrder',
  SpsCommerce: 'channels.SpsCommerce',
  Kitting: 'channels.Kitting',
  TikTok: 'channels.TikTok',
  Transportation: 'channels.Transportation'
}
